module.exports = __webpack_public_path__ + "img/european_union.871ae2e7.svg";